<template>
  <div class="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-gray-200">
    <div class="max-w-md">
      <h1 class="text-7xl font-bold text-gray-900 mb-4 tracking-tight">404</h1>
      <p class="text-2xl font-medium text-gray-700 mb-2">Ops! Página não encontrada</p>
      <p class="text-gray-500 mb-6">
        A página que você está procurando não existe ou foi movida.
      </p>
      <router-link
        to="/"
        class="inline-block border-b border-gray-300 px-6 py-2 rounded-lg text-sm font-medium shadow transition"
      >
        Voltar para a página inicial
      </router-link>
    </div>
  </div>
</template>
